module.exports = __webpack_public_path__ + "images/home_tree-5e5f08274a.png";